import { h, Fragment } from 'preact';
import KitProductSelector from './product-selector';
import ProductSkeleton from '../product-skeleton';
import { useKitProduct } from './product-context';

const KitProductSelectorGroup = () => {
  const { kitProducts } = useKitProduct();
  if (!kitProducts) {
    return <ProductSkeleton />;
  }

  return (
    <div className="flex flex-col justify-center gap-[20px] mb-[20px]">
      {kitProducts.map((product, index) => (
        <KitProductSelector key={index} index={index} {...product} />
      ))}
    </div>
  );
};

export default KitProductSelectorGroup;
